'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _nativeAdapter = require('@zz-common/native-adapter');

var _nativeAdapter2 = _interopRequireDefault(_nativeAdapter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ZZAPP = {};
var sdk = ['asyncIn', 'skipToUrl', 'skipToSearchResult', 'chooseMediaPhotos', 'isWechatApplication', 'share', 'login', 'switchTab', 'ApplyCustomerService', 'callTelephone', 'chooseAddress', 'close', 'closeLoadingDialog', 'editPublish', 'enlargeImage', 'enlargeImgsOrVideo', 'enterAssistantApply', 'enterBabyInfoPopUp', 'enterChat', 'enterConfirmOrder', 'enterCoterieApply', 'enterCoterieHome', 'enterCoterieList', 'enterCoterieManage', 'enterCoteriePublish', 'enterCoterieTopic', 'enterDetail', 'enterEvaluationDetail', 'enterFansList', 'enterFollowList', 'enterFriendAuthenList', 'enterFriendAuthentication', 'enterHelpCenter', 'enterHome', 'enterOrderDetail', 'enterPage', 'skipToDetail', 'skipToOrder', 'enterPassportBox', 'enterPayDeposit', 'enterProfile', 'enterPublish', 'enterPublishByInfoDraft', 'enterPublishMoment', 'enterReport', 'enterSearchResult', 'enterSysPushSetting', 'enterUnifiedUrl', 'enterUserFeedBack', 'enterZhimaScore', 'getCookie', 'getCoordinate', 'getInfoDraft', 'getNetworkAndCarrier', 'getSysPushSettingState', 'getUserId', 'invokePay', 'launchAlbum', 'launchWeChat', 'loadingEnd', 'loadingStart', 'log', 'login', 'nativeShare', 'refreshOrderInfo', 'resetRightAllButton', 'sendNotification', 'setBonusFlashStatus', 'setHeaderVisible', 'setRightBtn', 'setRightNativeBtn', 'setRightPublishMomentBtn', 'setRightReportBtn', 'setRightShareBtn', 'setRightUnifiedButton', 'setSearchBtn', 'setShareData', 'setSharePanel', 'setTitle', 'shareDealSuccessPoster', 'shareToPlatform', 'toast', 'uploadNativeLog', 'uploadPhotos', 'applyCallback', 'babyInfoCallback', 'clickCallback', 'coteriePublishCallback', 'getCookieCallback', 'getCoordinateCallback', 'getNACCallback', 'getUserIdCallback', 'launchAlbumCallback', 'loginCallback', 'publishCallback', 'shareCallback', 'stateCallback', 'uploadCallback', 'uploadNativeLogCallback', 'saveCalendarRemind', 'bindPhone', 'isBindPhone', 'subWechatOnceMessage', 'getQRCodeScan'];

_nativeAdapter2.default.instanceGenerator(sdk);
sdk.forEach(function (v) {
  ZZAPP[v] = function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (_nativeAdapter2.default[v]) {
      try {
        _nativeAdapter2.default[v].apply(window, args);
      } catch (e) {
        console.error(e);
      }
    } else {
      console.info('[警告]sdk没有该方法定义：' + v);
    }
  };
});

ZZAPP.enterDetail = function (obj, callback) {
  if (!'infoId' in obj) {
    console.error('infoId必填');
    return;
  }
  return _nativeAdapter2.default.skipToDetail(obj, callback);
};
ZZAPP.enterConfirmOrder = function (obj, callback) {
  return _nativeAdapter2.default.skipToOrder(obj, callback);
};
ZZAPP.toast = function (obj, callback) {
  if (_nativeAdapter2.default.client == 'zz') {
    return _nativeAdapter2.default.toast(obj, callback);
  } else {
    return window.eventHub.$emit('toast', obj.msg || '');
  }
};
ZZAPP.chooseAddress = function (obj, callback) {
  if (_nativeAdapter2.default.client === 'zz') {
    return _nativeAdapter2.default.chooseAddress(obj, callback);
  } else {
    return location.href = 'https://m.zhuanzhuan.com/trade/user-address/index.html?url=' + encodeURIComponent(location.href) + '&addressId=' + obj.addressId + '#/myAddress';
  }
};
exports.default = ZZAPP;